import React from 'react';
import { useForm } from '/src/components';
import WishListForm from '../../WishListForm';

const Edit = ({
    wishListId,
    name,
    visibility,
    handleUpdateWishList,
    isLoadingWishLists,
    children,
}) => {
    const { data, handleChange } = useForm({ name , visibility });

    const handleSubmit = e => {
        e.preventDefault();
        const { name, visibility } = data;

        handleUpdateWishList({ wishlistId: wishListId, name, visibility });
    };

    return (
        <WishListForm
            data={data}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            isLoadingWishLists={isLoadingWishLists}
        >
            {children}
        </WishListForm>
    )
};

export default Edit;
